import { isRequired } from 'Automations/nodeDefinitions/validation/validators'
import {
  allHandlesConnected,
  requiresDownstreamNode
} from 'Automations/nodeDefinitions/validation/nodeValidators'

export const triggerTypeRequired = isRequired({
  title: 'Missing type',
  message: 'Start node requires a type'
})

export const handlesConnected = allHandlesConnected({
  handleTypes: ['source'],
  title: 'Disconnected node',
  message: 'All handles must be connected'
})

export const requiresPublishQuote = requiresDownstreamNode({
  nodeType: 'ACTION_PUBLISH_QUOTE',
  title: 'Missing publish quote node',
  message: 'Workflow requires a publish quote node'
})

export const requiresContractExtraction = requiresDownstreamNode({
  nodeType: 'ACTION_CONTRACT_EXTRACTION',
  title: 'Missing extract contract node',
  message: 'Workflow requires an extract contract node'
})

export const requiresCreateSchedule = requiresDownstreamNode({
  nodeType: 'ACTION_CREATE_SCHEDULE',
  title: 'Missing create schedule node',
  message: 'Workflow requires a create schedule node'
})
